/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivityVersionItemDto } from '../../models/activity-version-item-dto';

export interface GetActivityVersions$Params {
  id: number;
}

export function getActivityVersions(http: HttpClient, rootUrl: string, params: GetActivityVersions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityVersionItemDto>>> {
  const rb = new RequestBuilder(rootUrl, getActivityVersions.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ActivityVersionItemDto>>;
    })
  );
}

getActivityVersions.PATH = '/api/activities/{id}/versions';
